import React from 'react';
import Main from 'views/layouts/Main/Main'; // Ensure this is the correct import path for your Main component

import { AllTherapies } from './AllTherapies';

const TherapeuticServices = () => {
	return (
		<Main sx={{ boxShadow: 0 }}>
			<AllTherapies />
		</Main>
	);
};

export default TherapeuticServices;
